import { useFormik } from 'formik';
import React from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
// import useGetOrganizations from '../../../../hooks/HR/use-get-organizations.js';
import { AddGroupEmp } from '../../../../store/HR/HRSetting/groupEmpSlice';
import { formGpoupEmp } from '../../../ValidationForm/validationSchema';

const AddGroupEmployees = () => {
  // const { Organizations } = useGetOrganizations();

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const formik = useFormik({
    initialValues: {
      name2: '',
      name: '',
      comments: '',
    },
    validationSchema: formGpoupEmp(t),
    onSubmit: (values, { resetForm }) => {
      dispatch(
        AddGroupEmp({
          name2: values.name2,
          name: values.name,
          businessGroupId: null,
          comments: values.comments,
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Add' });
          resetForm();
          document.getElementById('closeModalGroup').click();
          // dispatch(getGroupEmp());
        })
        .catch((error) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-xl-6">
          <div className="form-group mb-3">
            <label className="form-label">{t('LocalName')}</label>
            <Form.Control
              className="form-control"
              type="text"
              autoComplete="off"
              name="name"
              onChange={formik.handleChange}
              value={formik.values.name}
              isInvalid={!!formik.errors.name}
            />
            <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
          </div>
        </div>

        <div className="col-xl-6">
          <div className="form-group mb-3">
            <label className="form-label">{t('GlobalName')}</label>
            <Form.Control
              className="form-control"
              type="text"
              autoComplete="off"
              name="name2"
              onChange={formik.handleChange}
              value={formik.values.name2}
              isInvalid={!!formik.errors.name2}
            />
            <Form.Control.Feedback type="invalid">{formik.errors.name2}</Form.Control.Feedback>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="form-group mb-3">
            <label className="form-label">{t('Note')}</label>
            <Form.Control
              className="form-control"
              as="textarea"
              rows={3}
              name="comments"
              onChange={formik.handleChange}
              value={formik.values.comments}
              isInvalid={!!formik.errors.comments}
            />
            <Form.Control.Feedback type="invalid">{formik.errors.comments}</Form.Control.Feedback>
            <div></div>
          </div>
        </div>
      </div>

      <div className="text-center">
        <div className="d-flex justify-content-between gap-2">
          <button
            disabled={formik.isSubmitting}
            type="submit"
            className="btn btn-lg btn-theme mb-1 w-100">
            {formik.isSubmitting ? (
              <div className="spinner-border spinner-border-sm me-2"></div>
            ) : (
              <i className="fas fa-save fa-lg fa-fw me-2"></i>
            )}
            {t('Save')}
          </button>

          <button
            type="button"
            className="btn btn-lg  btn-default mb-1 w-100"
            data-bs-dismiss="modal"
            id="closeModalGroup">
            <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default AddGroupEmployees;
